module.exports = __webpack_public_path__ + "static/img/tjr.52b08d07.png";